export const site = {
  name: "SZ Interactive Ltd",
  shortName: "SZ Interactive",
  tagline: "Independent games. Serious engineering. Memorable worlds.",
  email: "info@szinteractive.co.uk",
  location: "United Kingdom",
  address: {
    street: "12 Constance Street",
    city: "London",
    postalCode: "E16 2DQ",
    country: "United Kingdom",
    countryCode: "GB"
  },
  established: "Established in Turkey in 2015",
  moved: "Moved to the United Kingdom in 2019",
  players: "75M+ players reached",
  instagram: "https://www.instagram.com/ludosdev/",
  baseUrl: "https://szinteractive.co.uk"
};

export const navItems = [
  { label: "Work", href: "/games" },
  { label: "Experience", href: "/experience" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" }
];

export const timeline = [
  { year: "2015", title: "Established in Turkey", text: "SZ Interactive begins as a hands-on independent studio focused on accessible, technically ambitious games." },
  { year: "Mobile era", title: "Multiple mobile releases", text: "A catalogue of mobile games across driving, physics, puzzles, horror, and accessible action helps establish an international audience." },
  { year: "75M+", title: "Global reach", text: "The studio's games have reached more than 75 million players around the world." },
  { year: "2019", title: "Moved to the United Kingdom", text: "SZ Interactive relocates to the UK and expands toward Steam, PC development, and more ambitious original projects." },
  { year: "Now", title: "Current projects", text: "The Shed and JEFF lead the current chapter, alongside selective technical development and collaboration work." }
];

export const referenceStudios = [
  { name: "Exient", href: "https://exient.com/" },
  { name: "Lava Labs", href: "https://www.lavalabs.gg/about" },
  { name: "Mild Panic Games", href: "https://www.mildpanic.co.uk/" },
  { name: "ByCodecGames", href: "https://www.bycodecgames.com/" }
];

export const routeMeta: Record<string, { title: string; description: string }> = {
  "/": {
    title: "SZ Interactive | Independent Game Studio & Unity Development",
    description: "SZ Interactive is a UK-based independent game studio established in Turkey in 2015, creating original games for Steam, PC and mobile."
  },
  "/games": {
    title: "Games | SZ Interactive",
    description: "Explore current and released games from SZ Interactive, including The Shed, JEFF, Truck Simulator Offroad, POV Car Driving, and Offroad Chronicles."
  },
  "/games/the-shed": {
    title: "The Shed | Narrative Mystery by SZ Interactive",
    description: "The Shed is a narrative mystery where time bends in a forgotten garden. Wishlist the game on Steam."
  },
  "/games/jeff": {
    title: "JEFF | Co-op Horde Shooter Published by SZ Interactive",
    description: "JEFF is a fast-paced co-op horde shooter and roguelite survival game published by SZ Interactive Ltd."
  },
  "/games/gobotix": {
    title: "Gobotix: Duo | Puzzle Game Published by SZ Interactive",
    description: "Gobotix: Duo is a two-robot isometric puzzle game published by SZ Interactive Ltd on Steam."
  },
  "/games/truck-simulator-offroad": {
    title: "Truck Simulator Offroad Series | SZ Interactive",
    description: "Truck Simulator Offroad is a released mobile off-road simulation series from SZ Interactive."
  },
  "/games/pov-car-driving": {
    title: "POV Car Driving | SZ Interactive",
    description: "POV Car Driving is a mobile driving game represented in the official SZ Interactive Wix trailer archive."
  },
  "/games/offroad-chronicles": {
    title: "Offroad Chronicles | SZ Interactive",
    description: "Offroad Chronicles is an off-road driving game represented in the official SZ Interactive Wix trailer archive."
  },
  "/games/gobotix-android": {
    title: "GoBotix Android | SZ Interactive",
    description: "GoBotix Android is a mobile puzzle game trailer entry from the official SZ Interactive Wix gallery."
  },
  "/games/horror-story-nancy-parker": {
    title: "Horror Story: Nancy Parker | SZ Interactive",
    description: "Horror Story: Nancy Parker is a horror game trailer entry from the official SZ Interactive Wix gallery."
  },
  "/experience": {
    title: "Experience | SZ Interactive",
    description: "Unity development, multiplayer, platform integration, pipelines, optimisation, and production experience from SZ Interactive."
  },
  "/about": {
    title: "About | SZ Interactive",
    description: "The story of SZ Interactive, established in Turkey in 2015 and based in the United Kingdom since 2019."
  },
  "/contact": {
    title: "Contact | SZ Interactive",
    description: "Contact SZ Interactive for games, roles, collaborations, publishing, or technical development work."
  },
  default: {
    title: "SZ Interactive",
    description: "Independent game studio and Unity development portfolio."
  }
};
